import { BrandMark } from "./BrandMark";
import { cn } from "@/shared/lib/cn";
import "./BrandWordmark.css";

export function BrandWordmark({ size = 22, className }: { size?: number; className?: string }) {
  return <span className={cn("studio-brand-wordmark", className)} style={{ fontSize: size }}>
    <BrandMark size={size * .96} /><span>afterform</span>
  </span>;
}
